const QueueCheck = () => {
    return Math.floor((Math.random() * 10) + 1);
}

export default QueueCheck;